import { makeAutoObservable } from "mobx";
import Destino from "../api/destino/destino";
import { getError } from "../util/util";

export class DestinoStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  loading = false;
  entities = [];

  filter = undefined;
  setFilter = (value) => {
    this.filter = value;
  };

  getAll = async () => {
    this.showLoading();
    try {
      const result = await Destino.getAll();
      if (result.success) {
        this.entities = result.data;
        if (result.data && result.data.length <= 0) {
          this.rootStore.alertStore.alertError("No se encontraron resultados");
        }
      }
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  getAllByFilter = async (data, isShowAlert = true) => {
    this.showLoading();
    try {
      const result = await Destino.getAllByFilter(data);
      if (result.success) {
        this.entities = result.data;
        if (result.data && result.data.length <= 0 && isShowAlert) {
          this.rootStore.alertStore.alertError("No se encontraron resultados");
        }
      }
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  create = async (data) => {
    this.showLoading();
    try {
      const result = await Destino.create(data);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertCreateSuccess();
      return Promise.resolve();
    } catch (error) {
      this.displayError(error);
      return Promise.error();
    } finally {
      this.hideLoading();
    }
  };

  update = async (data) => {
    this.showLoading();
    try {
      const result = await Destino.update(data);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertUpdateSuccess();
      return Promise.resolve();
    } catch (error) {
      this.displayError(error);
      return Promise.error();
    } finally {
      this.hideLoading();
    }
  };

  activeOrInActive = async (id) => {
    this.showLoading();
    try {
      const result = await Destino.activeOrInActive(id);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertUpdateSuccess();
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  deleteDestino = async (id) => {
    this.showLoading();
    try {
      const result = await Destino.delete(id);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertDeleteSuccess();
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  getAllOrFilter = () => {
    if (this.filter && this.filter?.value) {
      this.getAllByFilter(
        this.filter?.value !== 1 ? { IdEstatus: this.filter?.value } : {}
      );
    } else {
      this.getAll();
    }
  };

  showLoading = () => {
    this.rootStore.logisticBackdropStore.openLoading();
  };

  hideLoading = () => {
    this.rootStore.logisticBackdropStore.closeLoading();
  };

  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  };
}
